<template>
  <v-app
    id="inspire"
    :class="[
      {
        'box-layout': boxLayout,
        'collapse-sidebar': collapseSidebar
      }
    ]"
  >
    <router-view />

    <!-- <ChatLayer v-if="startChatApp && requireAuthPage" /> -->
    <GroupChatWindow v-if="useGroupChat" />

    <StickerMemo
      v-show="showMemo"
      v-for="(memo, index) in stickerMemoList"
      :index="index"
      :key="memo.id || memo.index"
      :memoConfig="memo"
      @deleteMemo="deleteMemoPopup"
      @copyMemo="copyMemo"
      @saveMemo="saveMemo"
      @addMemo="addMemo"
      @activeMemo="activeMemo"
      :hasMaxCount="hasMaxCount"
      :activeMemoUniqueKey="activeMemoUniqueKey"
      :showMemo="showMemo"
    />
    <!-- MsgPopup -->
    <dialog-popup></dialog-popup>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import StickerMemo from '@/components/StickerMemo';
import memoMixin from '@/mixins/memo';
import GroupChatWindow from '@/components/GroupChatWindow';
import { getShowGroupChatWorkplace } from './constants/customInfo';
import favicon from '@/assets/image/common/favicon_cg.png';

export default {
  name: 'App',
  mixins: [memoMixin],
  components: {
    StickerMemo,
    GroupChatWindow
  },
  metaInfo() {
    return {
      title: `클라우드기반의 채팅상담 솔루션`,
      titleTemplate: '클라우드게이트 - %s',
      link: [{ rel: 'shortcut icon', type: 'image/png', href: favicon }]
    };
  },
  data() {
    return {
      startChatApp: false,
      requireAuthPage: false,
      inactivityTimer: null,
      inactivityTimeout: 10 * 60 * 1000, // 10분
      lastActiveTime: null,
      useTimer: false,
      favicon
    };
  },
  computed: {
    ...mapGetters(['collapseSidebar', 'boxLayout', 'selectedLocale', 'isLoggedIn', 'getWorkPlaceId', 'isNeoWebRtc']),
    useGroupChat() {
      return this.startChatApp && this.requireAuthPage && getShowGroupChatWorkplace(this.getWorkPlaceId);
    }
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(value) {
        this.startChatApp = !!value;
      }
    },
    $route: {
      immediate: true,
      deep: true,
      handler(route) {
        this.requireAuthPage = route.meta.requiresAuth !== false;
      }
    }
  },
  created() {
    this.$eventBus.$on('globalExcelDownload', (url) => {
      const link = document.createElement('a');
      if (!url) return;
      link.href = url;
      link.target = '_self';
      link.click();
    });
    this.$eventBus.$on('change-start-chat-layer', (value) => {
      if (this.startChatApp === value) return;
      this.startChatApp = value;
    });

    this.$eventBus.$on('change-chat-layer-on', (value) => {
      this.useTimer = value;
      if (value) {
        this.addListeners();
        this.resetInactivityTimer();
      } else {
        this.removeListeners();
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        const now = this.$moment().format('YYYY.MM.DD HH:mm:ss');
        const diffMinutes = this.$moment(now).diff(this.$moment(this.lastActiveTime), 'minutes');

        if (diffMinutes >= 10) {
          // 🔒 잠금 모드 실행
          this.$eventBus.$emit('change-lock-status', true);
        }

        if (this.useTimer) {
          this.addListeners();
          this.resetInactivityTimer();
        }
      } else {
        this.lastActiveTime = this.$moment().format('YYYY.MM.DD HH:mm:ss');
        this.removeListeners();
      }
    });
  },
  mounted() {
    window.addEventListener('beforeunload', (event) => this.checkCloseOrRefresh(event));
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', (event) => this.checkCloseOrRefresh(event));
  },
  methods: {
    checkCloseOrRefresh(event) {
      if (!this.isNeoWebRtc) return;
      const localData = localStorage.getItem('call-agent-status');
      if (!localData) return;
      const callAgentStatus = JSON.parse(localData).status;
      if (callAgentStatus === '통화중') {
        // 통화중일 때에는 새로고침 관련 경고창 띄우기
        event.preventDefault();
        event.returnValue = '';
      } else {
        this.$store.dispatch('logOutWebPhoneBeforeClose');
      }
    },
    resetInactivityTimer() {
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.handleLock();
      }, this.inactivityTimeout);
    },
    handleLock() {
      // 예: 라우터 이동, 모달 띄우기 등
      // 이벤트 버스 -> groupChatWindow -> 새창에 postMessage
      this.$eventBus.$emit('change-lock-status', true);
    },
    addListeners() {
      const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
      events.forEach((evt) => window.addEventListener(evt, this.resetInactivityTimer));
    },
    removeListeners() {
      const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
      events.forEach((evt) => window.removeEventListener(evt, this.resetInactivityTimer));
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
    }
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue